import { ChangeDetectionStrategy, Component, ElementRef, HostListener } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { FocusConfig, ICON_TYPE } from "@spartacus/storefront";
import { switchMap, take, tap } from 'rxjs/operators';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { UntypedFormGroup } from '@angular/forms';
import { GenCheckoutService } from 'src/app/generac/services/checkout.service';
import { GenLaunchDialogService } from 'src/app/generac/services/launch-dialog.service';
import { Address } from '@spartacus/core';


@Component({
    selector: 'gen-edit-saved-address-dialog',
    templateUrl: './edit-saved-address-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenEditSavedAddressDialogComponent {
  private subscription = new Subscription();
  iconTypes = ICON_TYPE;
  loading: boolean = false;
  mode: string;

  savedAddressInit: Address;
  savedAddress: Address;
  isSaveAllowed: boolean = false;

  focusConfig: FocusConfig = {
    trap: true,
    block: true,
    autofocus: 'button',
    focusOnEscape: true,
  };

  @HostListener('click', ['$event'])
  handleClick(event: UIEvent): void {
    // Close on click outside the dialog window
    if ((event.target as any).tagName === this.el.nativeElement.tagName) {
      this.close('Cross click');
    }
  }

  constructor(
    protected launchDialogService: GenLaunchDialogService,
    protected el: ElementRef,
    private userAccount: UserAccountFacade,
    private checkoutService: GenCheckoutService,
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.launchDialogService.data$.subscribe(
        (data: any) => {
          this.savedAddressInit = data.savedAddress;
          this.mode = data?.savedAddress ? 'edit' : 'add';
        }
      )
    );
  }

  savedAddressChange(addressForm: UntypedFormGroup) {
    if (addressForm?.valid) {
      this.savedAddress = addressForm.getRawValue();
    }
    this.isSaveAllowed = addressForm?.valid;
  }


  public createOrEditSavedAddress(): Subscription {
    this.loading = true;
    return this.userAccount.get().pipe(
      take(1),
      switchMap((user) => this.mode == 'edit' ? this.editSavedAddress(user?.uid) : this.createSavedAddress(user?.uid)),
      tap(() => this.loading = false))
      .subscribe(() => {
        this.launchDialogService.closeDialog(this.savedAddress, 'EDIT_SAVED_ADDRESS');
      });
  }

  private editSavedAddress(userUid: string): Observable<any> {
    return this.checkoutService.editDropShipAddress(userUid, this.savedAddressInit.id, this.savedAddress)
  };

  private createSavedAddress(userUid: string): Observable<any> {
    return this.checkoutService.addDropShipAddress(userUid, this.savedAddress);
  };

  public close(reason: string): void {
    this.launchDialogService.closeDialog(reason, 'EDIT_SAVED_ADDRESS');
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.close('close dialog');
  }
}
